import {MessageCodes} from "../MessageCodes";
import ResultText from "../ResultText";
import ComparisonCSName from "../ComparisonCSName";
import ResultView from "../../../components/ResultView";
import ResultTable from "../../../components/table/ResultTable";
import ResultHeader from "../../../components/table/ResultHeader";
import ResultRow from "../../../components/table/ResultRow";
import ResultHeaderCell from "../../../components/table/ResultHeaderCell";
import ResultBody from "../../../components/table/ResultBody";
import ResultBodyCell from "../../../components/table/ResultBodyCell";
import HecRasHelper from "../../../helpers/HecRasHelper";
import EmptyLine from "../EmptyLine";
import ResultCellHighlight from "../../../components/table/ResultCellHighlight";

export function CXS6({data, message_key}) {
    return (
        <>
            {
                data?.result?.map(row => (
                    <ResultView error_id={row?.error_id} message_key={message_key}>
                        <Description row={row} globalVariables={data?.global_variables} />
                    </ResultView>
                ))
            }
        </>
    )
}

const Description = ({row, globalVariables}) => {
    switch (row.error_id) {
        case MessageCodes.Compare.SEC02.error_id: {
            return (
                <>
                    <ResultText>
                        There are differences in Bank Stations between {globalVariables?.sel_plan_title || 'base'} and {globalVariables?.tar_plan_title || 'comparison'} plan at the following {row?.data?.length} cross sections.
                        <EmptyLine />
                    </ResultText>
                    <ResultTable data={row?.data?.map(r => ({csName: r.cross_section, csNameVal: r.cross_section}))}>
                        <ResultHeader>
                            <ResultRow>
                                <ResultHeaderCell rowSpan={2} style={{textAlign: 'left', verticalAlign: 'bottom', width: HecRasHelper.getWidth(15)}}>River Station</ResultHeaderCell>
                                <ResultHeaderCell colSpan={2} style={{textAlign: 'center'}}>{globalVariables?.sel_plan_title || 'Base'}</ResultHeaderCell>
                                <ResultHeaderCell colSpan={2} style={{textAlign: 'center'}}>{globalVariables?.tar_plan_title || 'Comparison'}</ResultHeaderCell>
                            </ResultRow>
                            <ResultRow>
                                <ResultHeaderCell style={{textAlign: 'right', width: HecRasHelper.getWidth(12)}}>Left Bank</ResultHeaderCell>
                                <ResultHeaderCell style={{textAlign: 'right', width: HecRasHelper.getWidth(12)}}>Right Bank</ResultHeaderCell>
                                <ResultHeaderCell style={{textAlign: 'right', width: HecRasHelper.getWidth(12)}}>Left Bank</ResultHeaderCell>
                                <ResultHeaderCell style={{textAlign: 'right', width: HecRasHelper.getWidth(12)}}>Right Bank</ResultHeaderCell>
                            </ResultRow>
                        </ResultHeader>
                        <ResultBody>
                            {
                                row?.data?.map(item => (
                                    <ResultRow key={item.cross_section}>
                                        <ResultBodyCell style={{textAlign: 'left'}}>
                                            <ComparisonCSName csName={item.cross_section} />
                                        </ResultBodyCell>
                                        <ResultBodyCell style={{textAlign: 'right'}}>
                                            {item.base_left_bank}
                                        </ResultBodyCell>
                                        <ResultBodyCell style={{textAlign: 'right'}}>
                                            {item.base_right_bank}
                                        </ResultBodyCell>
                                        <ResultBodyCell style={{textAlign: 'right'}}>
                                            {ResultCellHighlight(item.base_left_bank, item.cmp_left_bank)}
                                        </ResultBodyCell>
                                        <ResultBodyCell style={{textAlign: 'right'}}>
                                            {ResultCellHighlight(item.base_right_bank, item.cmp_right_bank)}
                                        </ResultBodyCell>
                                    </ResultRow>
                                ))
                            }
                        </ResultBody>
                    </ResultTable>
                </>
            )
        }
        default: {
            return `Error Key Not Found: ${row.error_id}`
        }
    }
}
